var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dialog-title__container"},[_c('span',[_vm._t("default")],2),_c('button',{on:{"click":_vm.onClickClose}},[_c('svg-icon',{attrs:{"width":"20px","height":"20px","color":"accent","name":"fi-br-times-circle"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }